import { render, staticRenderFns } from "./DysfunctionDescriptionSlide.vue?vue&type=template&id=07a0d653&scoped=true&"
import script from "./DysfunctionDescriptionSlide.vue?vue&type=script&lang=js&"
export * from "./DysfunctionDescriptionSlide.vue?vue&type=script&lang=js&"
import style0 from "./DysfunctionDescriptionSlide.vue?vue&type=style&index=0&id=07a0d653&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a0d653",
  null
  
)

export default component.exports